import { MediaTypeEnum } from '../../../Common/Basic/enums/media-type.enum';

export class TableOfContentMentionModel {
    headline: string;
    mediaType: MediaTypeEnum;

    constructor(headline: string, mediaType: MediaTypeEnum) {
        this.headline = headline;
        this.mediaType = mediaType;
    }
}
